import Vue from "vue";
import Vuex from "vuex";

import auth from './modules/auth'
import orders from './modules/orders'
import entities from './modules/entities'
import autocomplete from './modules/autocomplete'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    orders,
    entities,
    autocomplete,
  }
})
